const themeStyles = colors => {
  const styles = {
    container: {
      position: 'relative',
      height: 280,
      width: '100%',
      backgroundColor: colors.white,
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '4px',
      boxShadow: '0px 3px 7px 0px rgba(0, 0, 0, 0.06)'
    },
    topContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '17px 22px',
      borderBottom: `1px solid ${colors.placebo}`,
      alignItems: 'center'
    },
    icon: {
      height: 32,
      width: 32,
      fill: colors.primary
    },
    title: {
      color: colors.approxBlack,
      fontSize: 16,
      fontWeight: 700,
      paddingLeft: 15,
      letterSpacing: '0.23px',
      lineHeight: '18.4px'
    },
    middleContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    bottomContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '36.5px',
      borderTop: `1px solid ${colors.placebo}`
    },
    link: {
      color: colors.primary,
      alignItems: 'center',
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '17px',
      cursor: 'pointer'
    },
    noData: {
      color: colors.secondaryGray,
      fontSize: 16,
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center'
    }
  }
  return styles
}

export default themeStyles
